// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls_controls__3ltpw"};